import { Box, HStack, Icon, Stack, Text } from "@chakra-ui/react"
import type { FC } from "react"

import type { Governor } from "query/graphql"
import WarningTriangleIcon from "ui/components/icons/WarningTriangleIcon"
import Web3Button from "web3/components/Web3Button"
import { getChainReferenceName } from "web3/helpers/chainReference"
import { chainIdToChainReference } from "web3/helpers/transformers"

type Props = {
  governance: Pick<Governor, "chainId">
}
const WalletConnectCorrectChain: FC<Props> = ({ governance }) => {
  const { chainId } = governance
  const chainReference = chainIdToChainReference(chainId)

  return (
    <Stack mt={4} spacing={2}>
      <HStack>
        <Icon as={WarningTriangleIcon} color="yellow.400" h={4} w={4} />
        <Text fontSize="sm" fontWeight="regular">
          You need to switch to {getChainReferenceName(chainReference)} network
          to proceed.
        </Text>
      </HStack>
      <Box>
        <Web3Button
          requiredChainId={governance.chainId}
          onValid={() => console.log("no-op")}
        >
          Switch network
        </Web3Button>
      </Box>
    </Stack>
  )
}

export default WalletConnectCorrectChain
